import ProductRatingStars from "../../../shared/components/ProductRatingStars";
import PropTypes from "prop-types";
import React from "react";

const Review = ({review}) => {
  const {
    date,
    name,
    rating,
    "review": memberReview,
    "rewards_tier": rewardsTier
  } = review;

  return (
    <div className="review-container">
      <div className="member-info">
        <ProductRatingStars
          averageRating={rating}
          forGrid={false}
        />
        <div className="name">
          <span>
            {name}
          </span>
          <span className="date">
            {date}
          </span>
        </div>
        <div className="rewards-tier">
          <span className="small">
            {rewardsTier}
          </span>
        </div>
      </div>
      <div className="rating-and-review">
        <ProductRatingStars
          averageRating={rating}
          forGrid={false}
        />
        <div className="review">
          <span className="small">
            {memberReview}
          </span>
        </div>
      </div>
      <div className="date">
        <span className="small">
          {date}
        </span>
      </div>
    </div>
  );
};

Review.propTypes = {
  "review": PropTypes.shape({
    "date": PropTypes.string.isRequired,
    "name": PropTypes.string.isRequired,
    "rating": PropTypes.number.isRequired,
    "review": PropTypes.string.isRequired,
    "rewards_tier": PropTypes.string.isRequired
  }).isRequired
};

export default Review;
